module.exports = __webpack_public_path__ + "img/Sprogreformation_Peter_Andreas_Munch.78fc8536.jpg";